import Marquee from 'react-fast-marquee';
import { Sparkle, Phone } from 'lucide-react';
import { SCHOOL, NOTICES } from '@/data/content';

const AnnouncementBar = () => {
  const items = [
    `Admissions Open · Session ${SCHOOL.session} — Limited Seats`,
    ...NOTICES.slice(0, 4).map((n) => n.title),
  ];
  return (
    <div data-testid="announcement-bar" className="bg-navy text-cream relative z-50">
      <div className="flex items-stretch">
        <div className="hidden sm:flex items-center gap-2 bg-crimson px-4 py-2 text-[11px] font-bold uppercase tracking-[0.2em] shrink-0">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-gold" />
          </span>
          Latest
        </div>
        <Marquee speed={35} gradient={false} className="py-2 text-xs sm:text-sm font-medium tracking-wide" pauseOnHover>
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="mx-6">{item}</span>
              <Sparkle className="h-3 w-3 text-gold fill-gold" aria-hidden="true" />
            </span>
          ))}
        </Marquee>
        <a
          data-testid="topbar-phone-link"
          href={`tel:${SCHOOL.phones[0].replace(/\s/g, '')}`}
          className="hidden md:flex items-center gap-2 px-4 text-xs font-semibold text-gold hover:text-cream transition-colors shrink-0 border-l border-cream/10"
        >
          <Phone className="h-3.5 w-3.5" /> {SCHOOL.phones[0]}
        </a>
      </div>
    </div>
  );
};

export default AnnouncementBar;
